export { default } from './TitleAndTextImage';
